import { FC } from 'react'
import DebounceSelect, {
  BaseValueType,
  FetchOptionsResult,
} from '../DebounceSelect'
import { GET_FILING_SEARCH_CUSTOMER_LIST } from '../../api/Filing'

interface Props {
  value?: string
  onChange?: (val?: string, option?: BaseValueType) => void
  disabled?: boolean
  placeholder?: string
  style?: React.CSSProperties
}

const CustomerUnitSelect: FC<Props> = ({
  value,
  onChange,
  disabled,
  placeholder,
  style,
}) => {
  const fetchOptions = async (
    search: string,
    pageNo: number = 1,
  ): Promise<FetchOptionsResult<BaseValueType>> => {
    const res = await GET_FILING_SEARCH_CUSTOMER_LIST({
      name: search,
      pageNo,
      pageSize: 20,
    })
    const list = res?.data?.content || []
    const totalPages = res?.data?.totalPages || 0
    const options = list.map((item) => ({
      key: item.mdmCode || item.customerName,
      label: item.customerName,
      value: item.customerName,
      mdmCode: item.mdmCode,
      crmExists: item.crmExists,
    }))
    return {
      options,
      hasMore: pageNo < totalPages,
      totalPages,
    }
  }

  return (
    <DebounceSelect
      value={value as any}
      onChange={(v, option) => onChange?.(v as any, option as any)}
      fetchOptions={fetchOptions}
      disabled={disabled}
      placeholder={placeholder || '请输入客户单位'}
      allowClear
      style={style}
    />
  )
}

export default CustomerUnitSelect
import { FC } from 'react'
import DebounceSelect, {
  BaseValueType,
  FetchOptionsResult,
} from '../DebounceSelect'
import { GET_FILING_SEARCH_CUSTOMER_LIST } from '../../api/Filing'

interface Props {
  value?: string
  onChange?: (val?: string, option?: BaseValueType) => void
  disabled?: boolean
  placeholder?: string
  style?: React.CSSProperties
}

const CustomerUnitSelect: FC<Props> = ({
  value,
  onChange,
  disabled,
  placeholder,
  style,
}) => {
  const fetchOptions = async (
    search: string,
    pageNo: number = 1,
  ): Promise<FetchOptionsResult<BaseValueType>> => {
    const res = await GET_FILING_SEARCH_CUSTOMER_LIST({
      name: search,
      pageNo,
      pageSize: 20,
    })
    const list = res?.data?.content || []
    const totalPages = res?.data?.totalPages || 0
    const options = list.map((item) => ({
      key: item.mdmCode || item.customerName,
      label: item.customerName,
      value: item.customerName,
      mdmCode: item.mdmCode,
      crmExists: item.crmExists,
    }))
    return {
      options,
      hasMore: pageNo < totalPages,
      totalPages,
    }
  }

  return (
    <DebounceSelect
      value={value as any}
      onChange={(v, option) => onChange?.(v as any, option as any)}
      fetchOptions={fetchOptions}
      disabled={disabled}
      placeholder={placeholder || '请输入客户单位'}
      allowClear
      style={style}
    />
  )
}

export default CustomerUnitSelect
